<template>
  <ErrorView
    v-if="this.game.teamDataError"
    style="height: 100vh"
    :message="this.game.teamDataError.message"
  />
  <div v-else-if="!loading">
    <vue-easy-lightbox
      :visible="lightboxImageIndex !== null"
      :imgs="[questionImageURL]"
      :index="lightboxImageIndex"
      @hide="lightboxImageIndex = null"
    ></vue-easy-lightbox>
    <Header :code="code" :team_id="team_id" :points="points" />
    <div class="cont-fullwidth">
      <div class="row">
        <!-- background texture layer -->
        <div class="fix-height">
          <div class="left-wrapper no-gutter-left no-gutter-right shadow">
            <!-- main image -->
            <div class="game-image shadow">
              <template
                v-if="challengeIndex == this.$constants.INTRO_CHALLENGE_INDEX"
              >
                <div
                  class="video-placeholder"
                  v-if="showVideoPlaceholder"
                  @click="showVideoPlaceholder = false"
                >
                  <div id="restart-video-icon">
                    <button class="btn-red">Replay Video</button>
                  </div>
                </div>
                <youtube
                  v-else
                  class="img-fluid shadow"
                  :video-id="gameData.intro.youtube"
                  :player-vars="{ autoplay: 1 }"
                  @ended="handleVideoPlaybackEnded"
                ></youtube>
              </template>
              <GameBoard
                v-else-if="
                  challengeIndex == null || currentQuestionData == null
                "
                :gameID="this.gameID"
                :gameboard="gameData.gameboard"
                :challenges="gameData.challenges"
                :challengeListEmbed="gameData.challengeListEmbed"
                :challengeSelectionText="gameData.challengeSelectionText"
                @challengeSelected="challengeSelected"
                @completedChallengeSelected="completedChallengeSelected"
                @blockedChallengeSelected="blockedChallengeSelected"
              ></GameBoard>
              <Pano
                class="img-fluid"
                v-else-if="currentQuestionData.pano"
                :gameID="this.gameID"
                :pano="currentQuestionData.pano"
              />
              <Embed
                v-else-if="currentQuestionData.embed"
                :gameID="this.gameID"
                :source="currentQuestionData.embed"
                @answer-updated="answerUpdated"
                @submit="submitAnswerClicked"
              />
              <!-- enlarge image -->
              <template v-else-if="currentQuestionData.image">
                <div id="enlarge-image">
                  <img
                    class="img-fluid"
                    src="@/assets/images/icons/be-icon-enlarge.svg"
                    alt="enlarge"
                  />
                </div>
                <img
                  class="img-fluid shadow zoomableImage"
                  :src="questionImageURL"
                  @click="lightboxImageIndex = 0"
                />
              </template>
              <template v-else-if="currentQuestionData.youtube">
                <div
                  class="video-placeholder"
                  v-if="showVideoPlaceholder"
                  @click="showVideoPlaceholder = false"
                >
                  <div id="restart-video-icon">
                    <button class="btn-red">Replay Video</button>
                  </div>
                  <img
                    class="video-placeholder-image img-fluid shadow"
                    :src="challengeImageURL"
                  />
                </div>
                <youtube
                  v-else
                  class="img-fluid shadow"
                  :video-id="currentQuestionData.youtube"
                  :player-vars="{ autoplay: 1 }"
                  @ended="handleVideoPlaybackEnded"
                ></youtube>
              </template>
              <img
                v-else
                class="img-fluid shadow"
                src="https://images.unsplash.com/photo-1511193311914-0346f16efe90?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2706&q=80"
                alt="game imge"
              />
            </div>

            <div
              id="instructions-rewards"
              class="d-flex align-items-center justify-content-start white-text vh-10 sidebar-progress"
            >
              <div
                class="vh-10 d-flex align-items-center col-6 no-gutter-left no-gutter-right rewards-button"
              >
                <router-link
                  :to="{
                    name: 'game-rewards',
                    params: { code: code, team_id: team_id }
                  }"
                  style="display: flex; height: 100%;
                width: 100%; align-content: center;"
                >
                  <div class="d-flex align-items-center">
                    <p
                      class="bold mt-0 pb-0 mb-0 alignleft pad-left-30"
                      style="z-index: 1"
                    >
                      Inventory
                    </p>
                    <div class="count-circle" style="z-index: 1">
                      {{ inventory.length }}
                    </div>
                    <img
                      src="@/assets/images/icons/be-icon-viewall.svg"
                      class="viewall-icon"
                      alt="view all"
                    />
                  </div>

                  <div class="reward-previews">
                    <img
                      v-for="(inventoryItem, index) in inventory.slice(-2)"
                      :key="index"
                      :src="resolveGameAssetURL(gameID, inventoryItem.image)"
                      alt="reward"
                      class="img-fluid"
                    />
                  </div>
                </router-link>
              </div>

              <div
                class="latest-activity-section vh-10 d-flex align-items-center col-6 no-gutter-left no-gutter-right pad-left-30 pad-right-30"
              >
                <div class="pad-right-30 w-100">
                  <p class="latest-activity bold pad-left-30">
                    Latest Activity
                  </p>
                  <div class="ticker-wrap">
                    <div class="ticker">
                      <div
                        v-for="(activityItem, index) in activity.activity"
                        :key="'act_' + index"
                        class="ticker__item"
                      >
                        {{ activityItem.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <GameSidebar
          :points="points"
          :progress="progress"
          :gameID="gameID"
          :inventory="inventory"
          :code="code"
          :team_id="team_id"
        /> -->

          <!-- sidebar -->
          <div class="right-wrapper no-gutter-left no-gutter-right">
            <div class="sidebar">
              <!-- game message window -->
              <div class="game-conversation">
                <!-- hint button -->
                <div
                  class="game-hint"
                  v-if="showHintButton()"
                  @click="if (!awaitingServerResponse) requestHint()"
                >
                  <a class="btn-white shadow">
                    <span>
                      <img
                        class="img-fluid vertical-align-middle"
                        src="@/assets/images/icons/hint-black.svg"
                        alt="hint"
                      />
                      Hint
                    </span>
                    <span
                      v-if="showRequestingHintSpinner"
                      style="display: inline-block !important"
                      class="button-loading-spinner submit"
                    ></span>
                  </a>
                </div>

                <Conversation
                  :messages="messages"
                  v-bind:show-placeholders="showMessagePlaceholders"
                  :messagePlaceholder="messagePlaceholder"
                  :timeRemaining="timeRemaining"
                  :maxTimeRemaining="maxTimeRemaining"
                  :pointsRemaining="pointsRemaining"
                  :timeReducesPoints="
                    currentQuestionData
                      ? currentQuestionData.timeReducesPoints
                      : false
                  "
                />
              </div>

              <!-- game answer / submit -->
              <div
                class="game-answer d-flex justify-content-center align-items-stretch"
              >
                <div
                  class="flex-fill "
                  :style="{
                    width:
                      showSubmitButton() || showDisabledSubmitButton()
                        ? ''
                        : '0vw'
                  }"
                >
                  <template
                    v-if="showSubmitButton() || showDisabledSubmitButton()"
                  >
                    <TemplatedTextQuestion
                      v-if="currentQuestionData.type === 'templatedText'"
                      :answer="currentQuestionData.answer"
                      :template="currentQuestionData.textTemplate"
                      :locked="currentQuestionData.correct !== undefined"
                      @answer-updated="answerUpdated"
                      @submit="submitAnswerClicked"
                    />
                    <FreeTextQuestion
                      v-else-if="
                        currentQuestionData.type === 'freeText' ||
                          currentQuestionData.type === 'freeTextOpen'
                      "
                      :answer="currentQuestionData.answer"
                      :locked="currentQuestionData.correct !== undefined"
                      @answer-updated="answerUpdated"
                      @submit="submitAnswerClicked"
                    />
                    <MultipleChoiceOptions
                      v-else-if="currentQuestionData.type === 'multipleChoice'"
                      :options="currentQuestionData.options"
                      :selectedOption="currentQuestionData.answer"
                      :locked="currentQuestionData.correct !== undefined"
                      @answer-updated="answerUpdated"
                    />
                  </template>
                </div>
                <div
                  v-if="
                    currentQuestionData != null ||
                      currentChallengeIndex ==
                        this.$constants.INTRO_CHALLENGE_INDEX
                  "
                  class="flex-fill "
                  :style="{
                    width:
                      showSubmitButton() || showDisabledSubmitButton()
                        ? ''
                        : '100vw'
                  }"
                >
                  <button
                    v-if="showSubmitButton()"
                    class="btn-red-form submit"
                    type="button "
                    @click="submitAnswerClicked"
                    :disabled="awaitingServerResponse"
                  >
                    Submit
                    <span
                      v-if="awaitingServerResponse"
                      class="button-loading-spinner"
                    ></span>
                  </button>
                  <button
                    v-else-if="showDisabledSubmitButton()"
                    class="btn-red-form submit btn-disabled-submit"
                    type="button"
                    disabled
                  >
                    Submit
                  </button>

                  <button
                    v-else
                    class="btn-red-form submit btn-next"
                    type="button"
                    @click="nextButtonPressed"
                    :disabled="awaitingServerResponse"
                  >
                    Next
                    <span
                      v-if="awaitingServerResponse"
                      class="button-loading-spinner submit"
                    ></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Game Mobile Footer -->

    <nav
      id="mobile-menu-footer"
      class="cont-fullwidth back-colour white-text visible-mobile shadow p-0"
    >
      <div class="row d-flex align-content-center vh-7-5 m-0">
        <div
          class="col-12 d-flex align-items-center justify-content-center no-gutter-left no-gutter-right"
        >
          <div
            id="game-menu-mobile-footer"
            class="row d-flex align-items-center justify-content-start w-100"
          >
            <template
              v-if="
                currentQuestionData != null ||
                  currentChallengeIndex == this.$constants.INTRO_CHALLENGE_INDEX
              "
            >
              <div
                v-if="showHintButton()"
                class="d-flex align-items-center justify-content-center menu-icon text-center w-50px"
              >
                <a @click="if (!awaitingServerResponse) requestHint()">
                  <span
                    v-if="showRequestingHintSpinner"
                    class="button-loading-spinner submit"
                  ></span>
                  <img
                    v-else
                    src="@/assets/images/icons/be-icon-hint.svg"
                    alt="hint"
                  />
                  <span class="title"></span>
                </a>
              </div>
              <div class="flex-fill w-50">
                <template
                  v-if="showSubmitButton() || showDisabledSubmitButton()"
                >
                  <!-- 🦊 add input -->
                  <TemplatedTextQuestion
                    v-if="currentQuestionData.type === 'templatedText'"
                    :answer="currentQuestionData.answer"
                    :template="currentQuestionData.textTemplate"
                    :locked="currentQuestionData.correct !== undefined"
                    @answer-updated="answerUpdated"
                    @submit="submitAnswerClicked"
                  />
                  <FreeTextQuestion
                    v-else-if="
                      currentQuestionData.type === 'freeText' ||
                        currentQuestionData.type === 'freeTextOpen'
                    "
                    :answer="currentQuestionData.answer"
                    :locked="currentQuestionData.correct !== undefined"
                    @answer-updated="answerUpdated"
                    @submit="submitAnswerClicked"
                  />
                  <MultipleChoiceOptions
                    v-else-if="currentQuestionData.type === 'multipleChoice'"
                    :options="currentQuestionData.options"
                    :selectedOption="currentQuestionData.answer"
                    :locked="currentQuestionData.correct !== undefined"
                    @answer-updated="answerUpdated"
                  />
                </template>
              </div>

              <template>
                <div
                  v-if="showSubmitButton()"
                  class="d-flex align-items-center justify-content-center menu-icon text-center  w-50px submit"
                >
                  <a
                    @click="submitAnswerClicked"
                    :disabled="awaitingServerResponse"
                    ><img
                      v-if="!awaitingServerResponse"
                      src="@/assets/images/icons/be-icon-submit.svg"
                      alt="submit"/><span
                      v-else
                      class="title button-loading-spinner"
                    ></span
                  ></a>
                </div>

                <div
                  v-else-if="showDisabledSubmitButton()"
                  class="d-flex align-items-center justify-content-center menu-icon text-center w-50px "
                  style="background: #bdbdbd"
                >
                  <!-- 🦊 add submit and next -->

                  <img
                    src="@/assets/images/icons/be-icon-submit.svg"
                    alt="submit"
                  /><span class="title"></span>
                </div>

                <!-- NEXT button -->

                <div
                  v-else
                  class="d-flex align-items-center justify-content-center menu-icon text-center termina-reg "
                  style="width: 100vw; background: #36b949; color: white !important; cursor: pointer"
                  :disabled="awaitingServerResponse"
                  @click="nextButtonPressed"
                >
                  <a @click="nextButtonPressed"
                    >Next
                    <span
                      v-if="awaitingServerResponse"
                      style="display: inline-block !important"
                      class="button-loading-spinner submit"
                    ></span
                  ></a>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import { mapState, mapActions } from 'vuex'
import MultipleChoiceOptions from '@/components/MultipleChoiceOptions.vue'
import FreeTextQuestion from '@/components/FreeTextQuestion.vue'
import TemplatedTextQuestion from '@/components/TemplatedTextQuestion.vue'
import Conversation from '@/components/Conversation.vue'
// import GameSidebar from '@/components/GameSidebar.vue'
import Pano from '@/components/Pano.vue'
import GameBoard from '@/components/GameBoard.vue'
import Embed from '@/components/Embed.vue'
import ErrorView from '@/components/ErrorView.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'
import { spookyNavMixin } from '../mixins/spookyNavMixin'
import { challengeNavigationMixin } from '../mixins/challengeNavigationMixin'
import moment from 'moment'

const TIMER_INTERVAL = 83 // Arbitrary number of milliseconds around 100 so that the milliseconds displayed in the component don't seem to decrement uniformly

export default {
  mixins: [gameAssetsMixin, spookyNavMixin, challengeNavigationMixin],
  components: {
    Header,
    MultipleChoiceOptions,
    FreeTextQuestion,
    TemplatedTextQuestion,
    Conversation,
    // GameSidebar,
    Pano,
    GameBoard,
    Embed,
    ErrorView,
    VueEasyLightbox
  },
  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true },
    challengeIndex: { required: true }
  },
  created() {
    if (this.gameData === undefined || this.game.teamData?.id != this.team_id) {
      this.fetchTeamData({ code: this.code, teamId: this.team_id })
    }

    this.fetchClockOffset()
  },
  data() {
    return {
      isInitialising: true,
      soundEffectPlayer: null,
      lightboxImageIndex: null,
      messages: [],
      messagePlaceholder: null,
      showVideoPlaceholder: false,
      initialLoadComplete: false,
      showMessagePlaceholders: false,
      timer: null,
      timeRemaining: null,
      pointsRemaining: null,
      rerenderKey: 1,
      answer: null,
      showRequestingHintSpinner: false
    }
  },
  mounted() {
    // If the page is mounted and the data is already
    // loasded then the watcher below won't fire for
    // question index changed so we need to fire it manually

    if (this.game.teamData?.gameData !== undefined) {
      this.startTimer()

      console.log(
        `🦄 mounted and got game data (current question index: ${this.currentChallengeData?.currentQuestionIndex})`
      )

      if (this.proposedChallengeIndex !== undefined) {
        this.handleProposedChallengeIndexChanged(
          this.proposedChallengeIndex,
          undefined
        )
      } else if (this.challengeIndex != this.currentChallengeIndex) {
        this.handleChallengeIndexChanged(
          this.currentChallengeIndex,
          this.challengeIndex
        )
      }

      this.$nextTick(function() {
        if (this.challengeIndex == this.$constants.GAMEBOARD_CHALLENGE_INDEX) {
          this.showChooseChallengeText()
        } else if (
          this.challengeIndex == this.$constants.INTRO_CHALLENGE_INDEX
        ) {
          this.showIntroText()
        } else {
          this.handleQuestionIndexChanged(
            this.currentChallengeData.currentQuestionIndex || 0,
            undefined
          )
        }
      })
    }

    setTimeout(() => {
      this.showMessagePlaceholders = true
      this.isInitialising = false

      if (
        this.challengeIndex == this.$constants.INTRO_CHALLENGE_INDEX &&
        this.messages.length === 0
      ) {
        this.showIntroText()
      }
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    if (to.name === 'challenge-play' && to.params.challengeIndex == -1) {
      console.log(`beforeRouteUpdate: moving to Game Board for first time`)

      document.body.classList.add('navigation-outer')
    } else {
      document.body.classList.remove('navigation-outer')
    }

    next()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === 'challenge-play') {
      if (
        from.name === 'challenge-play' &&
        from.params.challengeIndex !== to.params.challengeIndex
      ) {
        console.log(
          `beforeRouteUpdate: Challenge index changing. Resetting messages...`
        )
        this.messages = []
      }

      if (to.params.challengeIndex == this.$constants.INTRO_CHALLENGE_INDEX) {
        console.log(`beforeRouteUpdate: moving to Intro`)

        document.body.classList.remove('navigation-outer')

        this.$nextTick(function() {
          this.resetTimer()

          this.showIntroText()
        })
      } else if (
        to.params.challengeIndex == this.$constants.GAMEBOARD_CHALLENGE_INDEX
      ) {
        if (this.allChallengesComplete) {
          next(false)
          this.navigateToScoreboard()
          return
        }

        console.log(`beforeRouteUpdate: moving to Game Board`)

        this.$nextTick(function() {
          this.resetTimer()

          this.showChooseChallengeText()

          document.body.classList.add('navigation-outer')
        })
      } else {
        document.body.classList.remove('navigation-outer')
      }

      next()
    }
  },
  watch: {
    questionIndex(newValue, oldValue) {
      this.answer = null
      this.showVideoPlaceholder = false

      console.log(`questionIndex changing from ${oldValue} to ${newValue}`)
      this.$nextTick(function() {
        this.lightboxImageIndex = null

        this.awaitingServerResponse = false

        this.handleQuestionIndexChanged(newValue, oldValue)

        setTimeout(() => {
          this.showMessagePlaceholders = true
        }, 500)
      })
    },
    proposedChallengeIndex(newValue, oldValue) {
      this.handleProposedChallengeIndexChanged(newValue, oldValue)
    },
    currentChallengeIndex(newValue, oldValue) {
      this.handleChallengeIndexChanged(newValue, oldValue)
    },
    newestHintForCurrentQuestion(newValue, oldValue) {
      if (oldValue?.text === newValue?.text) {
        return
      }

      this.$nextTick(function() {
        this.showNewestHint()
      })
    },
    questionExpiryTime: function() {
      if (this.questionExpiryTime) {
        this.startTimer()
      } else {
        if (this.timer) {
          console.log('Stopping timer from watcher')
          this.resetTimer()
        }
      }
    },
    currentQuestionCorrect(newValue, oldValue) {
      console.log(
        `📛 WATCH: currentQuestionCorrect old: ${oldValue} -> new: ${newValue}`
      )

      if (this.isInitialising) {
        console.log(`📛 Ignoring becasue we are still initialising`)
        return
      }

      this.awaitingServerResponse = false

      if (
        this.currentQuestionData?.answer !== undefined &&
        this.currentQuestionData.answer !== ''
      ) {
        this.resetTimer()

        this.showAnswerText(this.currentQuestionData)

        if (this.currentQuestionData.correct !== undefined) {
          this.showQuestionAnswerResponse(this.currentQuestionData, true)
        }
      }
    }
  },
  computed: {
    ...mapState({
      game: state => state.game,
      activity: state => state.activity
    }),
    allChallengesComplete() {
      if (this.gameData?.challenges === undefined) {
        return false
      }

      return this.gameData.challenges.every(
        challenge => challenge.complete === true
      )
    },
    maxTimeRemaining() {
      if (!this.currentQuestionData?.timeToAnswer) {
        return null
      }

      return this.currentQuestionData.timeToAnswer * 1000
    },
    questionExpiryTime() {
      if (this.currentQuestionData?.answer) {
        return null
      }

      const rawExpiryTime = this.currentQuestionData?.expiryTime?.seconds

      if (rawExpiryTime) {
        const clockOffsetSeconds = this.game.clockOffset / 1000

        console.log(
          `Adjusting question expiry time for clock skew of ${clockOffsetSeconds} seconds`
        )

        var expiryDate = moment.unix(rawExpiryTime - clockOffsetSeconds)

        return expiryDate
      }

      return null
    },
    questionImageURL() {
      return this.resolveGameAssetURL(
        this.gameID,
        this.currentQuestionData?.image
      )
    },
    challengeImageURL() {
      return this.resolveGameAssetURL(
        this.gameID,
        this.currentChallengeData.image
      )
    },
    isSinglePlayer() {
      return this.game.teamData?.teamMembers.length <= 1
    },
    gameID() {
      return this.game.teamData?.game
    },
    points() {
      return this.game.teamData?.points.toString()
    },
    inventory() {
      return this.game.teamData?.inventory || []
    },
    progress() {
      return this.gameData?.progress || 0
    },
    gameData() {
      return this.game.teamData?.gameData
    },
    loading() {
      return this.gameData === undefined
    },
    currentChallengeData() {
      return this.gameData?.challenges[this.challengeIndex]
    },
    currentQuestionData() {
      return this.currentChallengeData?.questions[this.questionIndex]
    },
    currentQuestionCorrect() {
      return this.currentQuestionData?.correct
    },
    proposedChallengeIndex() {
      return this.gameData?.proposedChallengeIndex
    },
    currentChallengeIndex() {
      if (this.gameData === undefined) {
        return this.challengeIndex
      }

      return this.gameData?.currentChallengeIndex
    },
    questionIndex() {
      if (this.gameData === undefined || this.challengeIndex < 0) {
        return undefined
      }

      const index = this.currentChallengeData?.currentQuestionIndex

      if (index === undefined) {
        return 0
      }

      return index
    },
    currentQuestionUnusedHints() {
      let hints = this.currentQuestionData?.hints || []

      return hints.filter(hint => hint.used === false)
    },
    currentChallengeCharacter() {
      if (this.challengeIndex < 0) {
        return this.gameData?.challenges[0]?.character
      }

      return this.currentChallengeData?.character
    },
    newestHintForCurrentQuestion() {
      let hints = this.currentQuestionData?.hints || []

      let usedHints = hints.filter(hint => hint.used === true) || []

      return usedHints[usedHints.length - 1]
    }
  },
  methods: {
    ...mapActions('game', ['fetchTeamData', 'fetchClockOffset']),

    calculatePointsRemainingForQuestion(secondsRemaining) {
      let percentRemaining =
        secondsRemaining / this.currentQuestionData.timeToAnswer

      let pointsForQuestion = this.currentQuestionData.points
      var pointsRemaining = pointsForQuestion

      if (percentRemaining < 0.25) {
        pointsRemaining = Math.round(pointsForQuestion * 0.25)
      } else if (percentRemaining < 0.5) {
        pointsRemaining = Math.round(pointsForQuestion * 0.5)
      } else if (percentRemaining < 0.75) {
        pointsRemaining = Math.round(pointsForQuestion * 0.75)
      }

      return pointsRemaining
    },
    questionHasExpired() {
      return (
        this.questionExpiryTime && this.questionExpiryTime - moment.utc() < 0
      )
    },
    showSubmitButton() {
      if (this.currentChallengeIndex < 0) {
        return false
      }

      if (this.questionHasExpired()) {
        return false
      }

      if (!this.currentQuestionData) {
        return false
      }

      if (
        (this.answer !== null ||
          this.currentQuestionData?.answer !== undefined) &&
        this.currentQuestionData?.correct === undefined
      ) {
        return true
      }

      return false
    },
    showDisabledSubmitButton() {
      if (this.currentChallengeIndex < 0) {
        return false
      }

      if (this.questionHasExpired()) {
        return false
      }

      if (!this.currentQuestionData) {
        return false
      }

      if (
        this.currentQuestionData.type !== undefined &&
        this.answer === null &&
        this.currentQuestionData.answer === undefined
      ) {
        return true
      }

      return false
    },
    showHintButton() {
      if (this.currentChallengeIndex < 0) {
        return false
      }

      if (this.questionHasExpired()) {
        return false
      }

      if (!this.currentQuestionData) {
        return false
      }

      return (
        this.currentQuestionData?.correct === undefined &&
        this.currentQuestionUnusedHints.length > 0
      )
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timer = null
      this.timeRemaining = null
      this.pointsRemaining = null
    },
    startTimer() {
      console.log(' start timer')

      if (this.timer) {
        console.log(' stopping timer before starting new')
        clearInterval(this.timer)
        this.timer = null
      }

      if (!this.questionExpiryTime) {
        console.log('this.questionExpiryTime not set so not starting timer')
        return
      }

      this.timer = setInterval(() => {
        let timeRemaining = this.questionExpiryTime - moment.utc()

        if (isNaN(timeRemaining)) {
          console.log(`⏲ Timer Tick: Time Remaining is invalid. Skipping tick`)
          return
        }

        if (timeRemaining > 0) {
          this.timeRemaining = timeRemaining

          if (this.currentQuestionData.timeReducesPoints) {
            this.pointsRemaining = this.calculatePointsRemainingForQuestion(
              timeRemaining / 1000
            )
          }
        } else {
          this.timeRemaining = 0

          console.log("time's up")
          // this.rerenderKey += 1

          // TODO: Check for preconditions (TBD) and then answer question but with blank answer

          this.handleTimerExpired()

          clearInterval(this.timer)
          this.timer = null
        }
      }, TIMER_INTERVAL)
    },
    challengeSelected(index) {
      this.goToChallenge(index)
    },
    blockedChallengeSelected() {
      this.addMessage(
        'incoming',
        undefined,
        'That challenge is currently blocked. Choose another challenge.'
      )
    },
    completedChallengeSelected() {
      this.addMessage(
        'incoming',
        undefined,
        'That challenge has already been completed. Choose another challenge.'
      )
    },
    nextButtonPressed() {
      if (this.currentQuestionData) {
        this.goToNextQuestion()
      } else {
        this.goToGameBoard()
      }
    },
    goToGameBoard() {
      this.goToChallenge(this.$constants.GAMEBOARD_CHALLENGE_INDEX)
    },
    goToChallenge(index) {
      if (this.isSinglePlayer) {
        this.setCurrentChallengeIndex(this.code, this.team_id, index)
      } else {
        this.setProposedChallengeIndex(this.code, this.team_id, index)
      }
    },
    goToNextQuestion() {
      const isNextQuestion = this.gameData
        ? this.questionIndex < this.currentChallengeData.questions.length - 1
        : false

      this.awaitingServerResponse = true

      if (!isNextQuestion) {
        this.$store
          .dispatch('game/updateCurrentChallenge', {
            code: this.code,
            teamId: this.team_id,
            challengeIndex: this.$constants.GAMEBOARD_CHALLENGE_INDEX
          })
          .then(() => {
            this.awaitingServerResponse = false
          })
          .catch(error => {
            this.awaitingServerResponse = false

            //TODO: Handle error
            console.log('Error while updating current challenge index: ', error)
          })

        return
      }

      this.$store
        .dispatch('game/updateCurrentQuestion', {
          code: this.code,
          teamId: this.team_id,
          challengeIndex: this.challengeIndex,
          questionIndex: this.questionIndex + 1
        })
        .catch(error => {
          this.awaitingServerResponse = false

          this.addMessage(
            'incoming',
            'system',
            'Oops. An error occurred while getting next question: ' +
              error.toString()
          )
        })
    },
    playCorrectSound() {
      if (!this.gameData.correctSoundEffect) {
        return
      }

      if (!this.soundEffectPlayer) {
        return
      }

      this.soundEffectPlayer.src = this.resolveGameAssetURL(
        this.gameID,
        this.gameData.correctSoundEffect
      )
      this.soundEffectPlayer.play()
    },
    playIncorrectSound() {
      if (!this.gameData.incorrectSoundEffect) {
        return
      }

      if (!this.soundEffectPlayer) {
        return
      }

      this.soundEffectPlayer.src = this.resolveGameAssetURL(
        this.gameID,
        this.gameData.incorrectSoundEffect
      )

      this.soundEffectPlayer.play()
    },
    showMessagePlaceholder(from, text, icon) {
      this.messagePlaceholder = { type: 'placeholder', from, text, icon }
    },
    addMessage(type, from, text, icon) {
      this.messagePlaceholder = null

      if (from === undefined) {
        from = this.currentChallengeCharacter?.name
      }

      if (icon === undefined) {
        if (from !== 'system') {
          icon = this.resolveGameAssetURL(
            this.gameID,
            this.currentChallengeCharacter?.icon
          )
        } else {
          icon = require('@/assets/images/systemAvatar.svg')
        }
      }

      this.messages.push({ type, from, text, icon })
    },
    handleVideoPlaybackEnded() {
      this.showVideoPlaceholder = true

      if (this.currentQuestionData?.afterVideoText) {
        this.addMessage(
          'incoming',
          undefined,
          this.currentQuestionData?.afterVideoText
        )
      }
    },
    handleProposedChallengeIndexChanged(newValue, oldValue) {
      console.log(
        `🦊🦊🦊 GamePlay: proposedChallengeIndex changing from ${oldValue} to ${newValue}`
      )

      if (newValue === undefined && oldValue !== undefined) {
        // This means that the modal is currently displayed and the user
        // has responded, so now we need to hide it

        this.$modal.hide('propose-challenge-change-overlay')
        return
      }

      let message, submessage
      if (newValue == this.$constants.GAMEBOARD_CHALLENGE_INDEX) {
        if (
          this.currentChallengeIndex == this.$constants.INTRO_CHALLENGE_INDEX
        ) {
          if (this.gameData?.proposerName === undefined) {
            message = 'A player chose to go to the Game Board'
          } else {
            message = `${this.gameData?.proposerName} chose to go to the Game Board`
          }
        } else {
          if (this.gameData?.proposerName === undefined) {
            message = 'A player chose to return to the Game Board'
          } else {
            message = `${this.gameData?.proposerName} chose to return to the Game Board`
          }
        }
      } else if (newValue === this.$constants.INTRO_CHALLENGE_INDEX) {
        message = `Your devices are now synchronised!`
        if (this.gameData?.proposerName === undefined) {
          submessage = `A player chose to start the game`
        } else {
          submessage = `${this.gameData?.proposerName} chose to start the game`
        }
      } else {
        if (this.gameData?.proposerName === undefined) {
          message = `A player chose the ${this.gameData?.challenges[newValue].title} challenge`
        } else {
          message = `${this.gameData?.proposerName} chose the ${this.gameData?.challenges[newValue].title} challenge`
        }
      }

      this.$modal.show('propose-challenge-change-overlay', {
        proposedChallengeIndex: newValue,
        code: this.code,
        team_id: this.team_id,
        submessage: submessage,
        message: message
      })
    },
    navigateToScoreboard() {
      this.$router.push({
        name: 'game-scoreboard',
        params: { code: this.code, team_id: this.team_id }
      })
    },
    handleChallengeIndexChanged(newValue, oldValue) {
      console.log(
        `🦹‍♀️🦹‍♀️🦹‍♀️ currentChallengeIndex changing from ${oldValue} to ${newValue}`
      )

      this.$nextTick(function() {
        this.showVideoPlaceholder = false
      })

      this.lightboxImageIndex = null

      if (oldValue == newValue) {
        if (newValue == this.$constants.INTRO_CHALLENGE_INDEX) {
          console.log(`handleChallengeIndexChanged: moving to Intro`)

          this.resetTimer()

          this.showIntroText()
        } else if (newValue == this.$constants.GAMEBOARD_CHALLENGE_INDEX) {
          if (this.allChallengesComplete) {
            this.navigateToScoreboard()
            return
          }

          this.resetTimer()

          this.showChooseChallengeText()
        }

        return
      }

      if (
        newValue === undefined ||
        newValue === null ||
        newValue === this.$constants.GAMEBOARD_CHALLENGE_INDEX
      ) {
        console.log('🧙‍♀️Return to Challenge List')

        if (oldValue == this.$constants.INTRO_CHALLENGE_INDEX) {
          this.doSpookyNav(
            'challenge-play',
            {
              code: this.code,
              team_id: this.team_id,
              challengeIndex: newValue
            },
            'Loading',
            'Game Board'
          )
        } else {
          this.doSpookyNav(
            'challenge-play',
            {
              code: this.code,
              team_id: this.team_id,
              challengeIndex: newValue
            },
            'Returning to',
            'Game Board'
          )
        }
      } else if (newValue === this.$constants.INTRO_CHALLENGE_INDEX) {
        console.log(`🧟‍♂️Jump to intro`)

        this.doSpookyNav(
          'challenge-play',
          {
            code: this.code,
            team_id: this.team_id,
            challengeIndex: this.$constants.INTRO_CHALLENGE_INDEX
          },
          'Returning to',
          'Introduction'
        )
      } else if (newValue != this.challengeIndex) {
        console.log(
          `👩‍🚀👩‍🚀👩‍🚀 currentChallengeIndex (${newValue}) is no longer for this challenge (${this.challengeIndex})`
        )

        console.log(`🧟‍♂️Jump to another challenge: ${newValue}`)

        this.doSpookyNav(
          'challenge-play',
          {
            code: this.code,
            team_id: this.team_id,
            challengeIndex: newValue
          },
          'Loading Challenge',
          `${this.gameData?.challenges[newValue]?.title}`
        )
      }
    },
    handleQuestionIndexChanged(newValue, oldValue) {
      console.log(
        `📛 handleQuestionIndexChanged old: ${oldValue}, new: ${newValue}`
      )
      if (newValue === undefined) {
        return
      }

      if (oldValue === undefined) {
        oldValue = -1
      }

      if (!this.currentChallengeData) {
        return
      }

      for (let i = oldValue + 1; i <= newValue; i++) {
        let question = this.currentChallengeData.questions[i]

        this.showQuestionText(question)

        this.showHints(question.hints || [])

        if (question.answer !== undefined && question.answer !== '') {
          this.showAnswerText(question)

          if (question.correct !== undefined) {
            this.showQuestionAnswerResponse(question, false)
          }
        }
      }
    },
    showQuestionText(question) {
      const from = question.character?.name
      const icon = question.character?.icon
        ? this.resolveGameAssetURL(this.gameID, question.character.icon)
        : undefined

      if (question.texts) {
        question.texts.forEach(text => {
          this.addMessage('incoming', from, text, icon)
        })
      } else if (question.text) {
        this.addMessage('incoming', from, question.text, icon)
      }
    },
    showAnswerText(question) {
      if (question.answer === '<expired>') {
        this.addMessage('outgoing', 'user', 'Time ran out!')
        return
      }

      if (question.type === 'multipleChoice') {
        this.addMessage(
          'outgoing',
          'user',
          question.options[question.answer].text
        )
      } else {
        this.addMessage('outgoing', 'user', question.answer)
      }
    },
    showQuestionAnswerResponse(question, playSoundEffects) {
      console.log(`📛 showQuestionAnswerResponse`)
      if (question.correct) {
        if (playSoundEffects) {
          this.playCorrectSound()
        }
        this.addMessage('correct', undefined, question.correctResponse)
      } else {
        if (playSoundEffects) {
          this.playIncorrectSound()
        }
        this.addMessage('incorrect', undefined, question.incorrectResponse)
      }
    },
    showHints(hints) {
      hints.forEach(hint => {
        if (hint?.used) {
          this.addMessage('hint', undefined, hint.text)
        }
      })
    },
    showUsedHints() {
      this.showHints(this.currentQuestionData?.hints || [])
    },
    showNewestHint() {
      this.showHints([this.newestHintForCurrentQuestion])
    },
    showIntroText() {
      this.addMessage('incoming', undefined, this.gameData.intro.text)
    },
    showChooseChallengeText() {
      this.addMessage(
        'incoming',
        undefined,
        this.gameData.challengeSelectionText
      )
    },
    requestHint() {
      console.log('jslfkjdlkfj')
      if (this.currentQuestionUnusedHints.length === 0) {
        this.addMessage(
          'incoming',
          undefined,
          'Sorry, you have no unused hints for this question.'
        )

        return
      }

      this.showRequestingHintSpinner = true
      setTimeout(() => {
        this.showRequestingHintSpinner = false
      }, 2000)

      console.log('DEBUG: Submitting hint request.')

      this.$store
        .dispatch('game/requestHint', {
          code: this.code,
          teamId: this.team_id,
          challengeIndex: this.challengeIndex,
          questionIndex: this.questionIndex
        })
        .catch(error => {
          this.addMessage(
            'incoming',
            'system',
            'Oops. An error occurred while requesting a hint: ' +
              error.toString()
          )
        })
    },
    answerUpdated(answer) {
      this.answer = answer
    },
    submitAnswerClicked() {
      this.submitAnswer()
    },
    handleTimerExpired() {
      let randomInterval = Math.ceil(Math.random() * 1000)
      console.log(
        `⏳ Timer expired. Waiting ${randomInterval} milliseconds before submitting answer...`
      )

      let challengeIndex = this.currentChallengeIndex
      let questionIndex = this.questionIndex

      setTimeout(() => {
        if (
          this.currentQuestionCorrect !== undefined ||
          challengeIndex !== this.currentChallengeIndex ||
          questionIndex !== this.questionIndex
        ) {
          console.log(`⏳ After delay, question has already been answered.`)
          return
        }
        this.submitAnswer(true)
      }, randomInterval)
    },
    submitAnswer(timerHasExpired = false) {
      console.log(`TImer has expred: ${timerHasExpired}`)
      if (!this.soundEffectPlayer) {
        this.soundEffectPlayer = new Audio()
        this.soundEffectPlayer.play()
      }

      if (!timerHasExpired && !this.showSubmitButton()) {
        return
      }

      let data = {
        type: this.currentQuestionData.type,
        answer: this.answer
      }

      if (timerHasExpired) {
        data.timerExpired = true
        data.answer = '<expired>'
      }

      console.log('DEBUG: Submitting question data: ' + JSON.stringify(data))

      this.awaitingServerResponse = true

      this.$store
        .dispatch('game/answerQuestion', {
          code: this.code,
          teamId: this.team_id,
          challengeIndex: this.challengeIndex,
          questionIndex: this.questionIndex,
          data
        })
        .then(() => {
          if (this.currentQuestionData?.autoAdvance) {
            console.log('Auto advancing...')
            this.goToNextQuestion()
          } else {
            console.log('Auto advance not set.')
          }
        })
        .catch(error => {
          this.awaitingServerResponse = false
          this.addMessage(
            'incoming',
            'system',
            'Oops. An error occurred while checking your answer: ' +
              error.toString()
          )
        })
    }
  }
}
</script>
<style scoped>
.zoomableImage {
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.video-placeholder {
  animation: fadeIn ease 1s;
}
.count-circle {
  background: #f94444;
  width: 25px;
  text-align: center;
  border-radius: 25px;
  height: 25px;
  font-size: 100% !important;
  line-height: 25px !important;
  margin-left: 5px;
}
.reward-previews {
  position: absolute;
  top: 0;
  width: 100% !important;
  opacity: 0.5;
  z-index: 0;
  height: 100% !important;
  left: 0;
  right: 0;
  pointer-events: none !important;
  overflow: hidden !important;
}
.rewards-button {
  transition: all ease-in-out 0.4s;
}
.rewards-button:hover {
  background: #ba2819;
  transition: all ease-in-out 0.4s;
}
.rewards-button:hover > .reward-previews {
  opacity: 0.75;
  transition: all ease-in-out 0.4s;
}
.reward-previews img {
  max-width: 25% !important;
  object-fit: contain;
  object-fit: contain;
  height: 100% !important;
  float: right;
  padding-right: 15px;
}

* {
  box-sizing: border-box;
}

@-webkit-keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

@keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }

  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.ticker-wrap {
  position: fixed;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 10vh;
  padding-left: 5%;
  box-sizing: content-box;
}
.ticker {
  display: inline-block;
  height: 10vh;
  line-height: 10vh;
  white-space: nowrap;
  padding-right: 100%;
  box-sizing: content-box;

  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: ticker;
  animation-name: ticker;
  -webkit-animation-duration: 45s;
  animation-duration: 45s;
}
.ticker__item {
  display: inline-block;
  /* padding: 0 1rem; */
  padding-top: 10px;
  font-size: inherit;
  font-family: termina, sans-serif !important;
  color: white;
}
</style>
